import { createHttpClient } from '@adapters/HttpClient';
import { ProfitabilityApiAdapter } from '../adapters/ProfitabilityApiAdapter';
import type { ProfitabilitySummaryDailyQuery, ProfitabilitySummaryDailyResponse } from '../models/Profitability';
import { apiClientWH } from '@shared/services';
import { useQuery } from '@tanstack/react-query';

const httpClient = createHttpClient(apiClientWH);
const adapter = new ProfitabilityApiAdapter(httpClient);

export const useProfitabilitySummaryDaily = (query: ProfitabilitySummaryDailyQuery | undefined, enabled = true) => {
  return useQuery<ProfitabilitySummaryDailyResponse, Error>({
    queryKey: [
      'profitability',
      'summary-daily',
      query?.start_date,
      query?.end_date,
      query?.date_column,
      query?.shop_id,
      query?.payment_method_id,
      query?.shipment_status_id,
    ],
    queryFn: () => adapter.getSummaryDaily(query),
    enabled: enabled && !!query?.start_date && !!query?.end_date,
    staleTime: 60 * 1000,
  });
};
